import { PAY_ICON_PATHS } from "@/components/PlanIcon";
import { NAV_ICON_PATHS } from "@/components/NavIcon";
import { PRICING_ICON_PATHS } from "@/components/PricingIcon";
import { box, ln, mark, we, wp, type HandPart } from "@/components/hand-icon";

/*
  青い旗の札 (Flag) の字の前に付ける線の図記号。札の言葉から図記号への対応表を1か所に置く。
  ヘッダーのメニューと同じ言葉 (学ぶ中身、作るもの、受講生の声、手に入るもの、料金、よくある質問) は NavIcon と同じ形にそろえ、
  メニューと節の札が同じ印になるようにしてある。表に無い言葉は図記号なしで出る。
  描き方は @/components/hand-icon の「B 手の揺れの太線」。新しい札の言葉を足したら、ここに1行足す
*/
const open = (pts: [number, number][], r = 1) => wp(pts, { closed: false, r });
const FLAG: HandPart[] = [
  ln(5, 21, 5, 3),
  mark(
    wp(
      [
        [5, 4],
        [18, 4],
        [14.8, 8],
        [18, 12],
        [5, 12],
      ],
      { r: 0.8 },
    ),
  ),
];
const CALENDAR: HandPart[] = [
  box(3, 5, 18, 15.8),
  "M8 2.6v3.6M16 2.6v3.6",
  ln(3.2, 9.8, 20.8, 9.8),
  "M7.4 13.6h.01M11.2 13.6h.01M7.4 17.4h.01M11.2 17.4h.01",
  mark(we(15.6, 15.4, 2.2)),
];
const CODE: HandPart[] = [
  open([
    [8, 5.6],
    [2.6, 12],
    [8, 18.4],
  ]),
  open([
    [16, 5.6],
    [21.4, 12],
    [16, 18.4],
  ]),
];
const SWAP: HandPart[] = [
  ln(4.2, 7.4, 19.8, 7.4) +
    open([
      [7.8, 3.6],
      [4, 7.4],
      [7.8, 11.2],
    ]),
  ln(4.2, 16.6, 19.8, 16.6) +
    open([
      [16.2, 12.8],
      [20, 16.6],
      [16.2, 20.4],
    ]),
];
const PLAY: HandPart[] = [
  mark(
    wp(
      [
        [6, 3.6],
        [20, 12],
        [6, 20.4],
      ],
      { r: 2 },
    ),
  ),
];
const ARTICLE: HandPart[] = [
  wp(
    [
      [4.6, 2.6],
      [14, 2.6, 0.6],
      [19.4, 8, 0.6],
      [19.4, 21.4],
      [4.6, 21.4],
    ],
    { r: 2 },
  ),
  open([
    [14, 3],
    [14, 8],
    [19, 8],
  ]),
  mark(box(8, 11.4, 8, 4, 1)),
  ln(8.4, 18.4, 13.4, 18.4),
];

const FLAG_ICON_PATHS: Record<string, HandPart[]> = {
  料金: NAV_ICON_PATHS.cost,
  料金プラン: NAV_ICON_PATHS.cost,
  学ぶ中身: NAV_ICON_PATHS.curriculum,
  ゆめさく独自の学び方: NAV_ICON_PATHS.curriculum,
  "30日の中身": NAV_ICON_PATHS.curriculum,
  作るもの: NAV_ICON_PATHS.projects,
  受講生の声: NAV_ICON_PATHS.voices,
  ほかのインタビュー: NAV_ICON_PATHS.voices,
  手に入るもの: NAV_ICON_PATHS["what-you-get"],
  よくある質問: NAV_ICON_PATHS.faq,
  講師: PRICING_ICON_PATHS.user,
  女性エンジニア図鑑: PRICING_ICON_PATHS.user,
  ゆめさくエンジニアとは: PRICING_ICON_PATHS.user,
  現役エンジニアが作った: PRICING_ICON_PATHS.briefcase,
  現役エンジニアも: PRICING_ICON_PATHS.briefcase,
  エンジニアの今: PRICING_ICON_PATHS.rise,
  "18ヶ月後": PRICING_ICON_PATHS.graduate,
  "30日のあと": PRICING_ICON_PATHS.rise,
  続けられる仕組み: PRICING_ICON_PATHS.clock,
  扱う技術: CODE,
  一緒に開発: CODE,
  はじめ方: FLAG,
  "30日間無料の課題": CALENDAR,
  無料30日チャレンジ: CALENDAR,
  毎日の1つ: CALENDAR,
  お支払い方法: PAY_ICON_PATHS.card,
  分割払い: PRICING_ICON_PATHS.wallet,
  他社との違い: SWAP,
  インタビュー動画: PLAY,
  インタビュー記事: ARTICLE,
  ポイント: PRICING_ICON_PATHS.check,
};

export function flagIconPaths(label: string): HandPart[] | undefined {
  return FLAG_ICON_PATHS[label];
}
